export default function Hero() {
  const stats = [
    { value: '每日更新', label: '持续追踪热点' },
    { value: '全维度覆盖', label: '八卦娱乐爆料' },
    { value: '匿名投稿', label: '保护爆料人隐私' },
  ];

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20red%20and%20crimson%20gradient%20abstract%20background%20with%20subtle%20overlapping%20circles%20and%20geometric%20patterns%2C%20mysterious%20atmosphere%2C%20editorial%20news%20style%2C%20warm%20dark%20tones%2C%20no%20text%2C%20no%20people%2C%20smooth%20gradient%20from%20deep%20burgundy%20to%20black%2C%20minimal%20abstract%20composition&width=1600&height=900&seq=hero-bg-911&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-semibold tracking-wider uppercase mb-4 border border-primary-500/30">
              实时追踪 · 深度爆料
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-3">
              911爆料网 · 你的吃瓜第一站
            </h1>

            <p className="text-base md:text-lg text-background-50/80 font-bold font-heading mb-4">
              热点八卦一网打尽，最新爆料永不掉队
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-6 max-w-[600px] mx-auto lg:mx-0">
              911爆料网是专注吃瓜内容的聚合平台，每日追踪娱乐圈最新动态与网络热议事件。从明星绯闻到社会热点，从综艺爆料到网红八卦，我们以最快速度为你梳理事件脉络、挖掘深度内幕，让每一次"吃瓜"都有料、有据、有态度。当前平台已覆盖娱乐圈、综艺圈、直播圈等多维度爆料内容，支持匿名投稿，保护每一位爆料人的隐私安全。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {stats.map((stat, i) => (
                <div key={i} className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                  <span className="text-sm text-background-50/80">
                    <strong className="text-background-50">{stat.value}</strong>
                    <span className="text-background-50/60"> · {stat.label}</span>
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热度榜
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 font-medium rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative grid grid-cols-2 gap-3">
                <div className="aspect-[3/4] rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20style%20photograph%20of%20a%20spotlight%20on%20a%20dark%20stage%20with%20microphone%20silhouette%2C%20red%20curtain%20background%2C%20mysterious%20entertainment%20news%20aesthetic%2C%20warm%20cinematic%20lighting%2C%20no%20text%2C%20no%20people%2C%20professional%20photography&width=600&height=800&seq=hero-card-1&orientation=portrait"
                    alt="娱乐爆料舞台"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col gap-3">
                  <div className="aspect-[4/3] rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20stack%20of%20newspapers%20and%20magazines%20with%20dramatic%20lighting%20in%20a%20dark%20room%2C%20red%20and%20warm%20accents%2C%20breaking%20news%20aesthetic%2C%20editorial%20photography%20style%2C%20no%20text%2C%20mysterious%20atmosphere%2C%20professional%20composition&width=600&height=450&seq=hero-card-2&orientation=landscape"
                      alt="爆料新闻"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="aspect-[4/3] rounded-xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20closeup%20of%20a%20magnifying%20glass%20over%20social%20media%20icons%20on%20a%20dark%20surface%2C%20warm%20red%20and%20amber%20lighting%2C%20investigative%20journalism%20concept%2C%20no%20text%2C%20mysterious%20dramatic%20mood%2C%20professional%20product%20photography&width=600&height=450&seq=hero-card-3&orientation=landscape"
                      alt="深度追踪"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}